'use strict';

exports = module.exports = require('./dist')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/react-intl/~/intl-format-cache/index.js
// module id = 5554
// module chunks = 0